import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, UserLogin } from "ngx-sds-login";
import { Observable, Subject, takeUntil } from "rxjs";
import { Solicitud } from "src/app/infraestructure/interfaces/referente/SolicitudDTO";
import { SolicitudCambiarEstadoI } from "src/app/infraestructure/models/solicitudCambiarEstado.interface";
import { ReferentApiService } from "src/app/infraestructure/services/referent/referent-api.service";
import Swal from "sweetalert2";


@Component({
  selector: "app-ajuste-solicitud-servicios",
  templateUrl: "./ajuste-solicitud-servicios.component.html",
  styleUrls: ["./ajuste-solicitud-servicios.component.scss"],
})
export class AjusteSolicitudServiciosComponent implements OnInit {
  
  codeSolicitud: number = 0;
  private $topSubcription = new Subject<void>();
  user$: Observable<UserLogin>;

  dataSolicitud = {} as SolicitudCambiarEstadoI;
  rolId: number = 0;
  userId: number = 0;

  constructor( private route: ActivatedRoute, 
               private referentApiSrv: ReferentApiService,
               private router: Router,
               private store: Store<AppState>,) {
      this.user$ = this.store.select(state => state.user);
      this.user$.subscribe(user => {
        this.rolId = user.rolId;
        this.userId = user.id;
    });
  }

  ngOnInit(): void {
    this.codeSolicitud = Number(this.route.snapshot.paramMap.get('id'));
  }

  updateSolicitud(solicitud: Solicitud) {

    this.referentApiSrv.putSolicitudServicio(solicitud)
    .pipe(takeUntil(this.$topSubcription))
    .subscribe( res => {
      if (res.code === 200) {
        this.actionSucces('Ajustes exitosos', `Se actualizó la solicitud de servicio #${res.data.id} de manera exitosa`);
        this.onCambiarEstado();
      } else {
        const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
        Swal.fire({
          title: 'Errores',
          icon: 'error',
          html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
          showConfirmButton: true,
          confirmButtonColor: "#004884",
          confirmButtonText: "ACEPTAR",
        });
      }
    })
  }

  actionSucces(title: string, message: string) {
    Swal.fire({
      position: "center",
      icon: "success",
      title: `${title}`,
      text: `${message}`,
      showConfirmButton: true,
      confirmButtonColor: "#004884",
      confirmButtonText: "ACEPTAR",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        this.router.navigate(['/seguimiento-solicitudes-referente']);
      }
    });
  }

  onCambiarEstado() {
    this.dataSolicitud.rolId = this.rolId;
    this.dataSolicitud.usuarioId = this.userId;
    this.dataSolicitud.solicitudId = this.codeSolicitud;
    this.dataSolicitud.accion = 'ENVIAR_SIGUIENTE_ESTADO';
    this.dataSolicitud.datos = {};

    this.referentApiSrv.putSolicitudCambiarestado(this.dataSolicitud)
    .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.router.navigate(['/seguimiento-solicitudes-referente']);
        } else {
          const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
          
          Swal.fire({
            title: 'Errores',
            icon: 'error',
            html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
            showConfirmButton: true,
            confirmButtonColor: "#004884",
            confirmButtonText: "ACEPTAR",
          });
        }
      });
  }
}
